import React, { createContext, useContext, useState, useEffect } from "react";

interface Config {
  reportLimit: number;
  reportTaskType: string;
  reports: Report[];
  producer: DocumentGroup[];
  modelPortfolios: number[];
  modelPortfolioDetails: number[];
  modelSecurities: number[];
  securities: Securities;
}
interface Securities {
  askApprovedTag: string;
}
export interface Report {
  id: number;
  title: string;
  description: string;
  reportDependencies: string[];
  reportType: "pdf" | "xlsx";
}
interface Document {
  id: string;
  title: string;
}
interface DocumentGroup {
  id: string;
  title: string;
  documents: Document[];
}

interface ConfigContextValue {
  config: Config | null;
  loading: boolean;
}

const ConfigContext = createContext<ConfigContextValue | null>(null);

export const ConfigProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [config, setConfig] = useState<Config | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadConfig = async () => {
      try {
        // Get the base path from package.json homepage or use process.env.PUBLIC_URL
        const basePath = process.env.PUBLIC_URL || "";
        const configUrl = `${window.location.origin}${basePath}/config/config.json`;

        const response = await fetch(configUrl);
        const data: Config = await response.json();
        setConfig(data);
      } catch (error) {
        console.error("Failed to load config:", error);
      } finally {
        setLoading(false);
      }
    };

    loadConfig();
  }, []);

  return (
    <ConfigContext.Provider value={{ config, loading }}>
      {children}
    </ConfigContext.Provider>
  );
};

// Hook to use Config
export const useConfig = () => {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error("useConfig must be used within a ConfigProvider");
  }
  return context;
};
